import { Box, Button, NeoColor, Stack } from "@noom/wax-component-library";
import { useTranslation } from "react-i18next";

import plusIcon from "../../../image_assets/plus_icon.svg";
import {
  MedCtaAction,
  trackPrescriptionWebviewCtaTapped,
} from "../../nativeAnalytics/medAnalytics";
import { openDeeplink } from "../utils";

import {
  MEDICATION_HISTORY_DEEPLINK,
  MEDICATION_TRACKER_DEEPLINK,
} from "./medLogDeeplinks";

type TreatmentMedLogCtasProps = {
  medicationName: string;
};

/**
 * Figma Med header CTAs for logging state: secondary "Med history" +
 * primary "Log" (with plus). Opens native deeplinks via `openDeeplink`.
 */
export const TreatmentMedLogCtas = ({
  medicationName,
}: TreatmentMedLogCtasProps) => {
  const { t } = useTranslation("care", { useSuspense: false });
  const historyLabel = t("detail.medLog.history");
  const logLabel = t("detail.medLog.log");

  return (
    <Stack
      data-cy="treatment-med-log-ctas"
      isInline
      spacing={2}
      width="100%"
      pt={4}
      pb={2}
      align="center"
    >
      <Button
        data-cy="treatment-med-log-history"
        size="sm"
        variant="solid"
        colorScheme="secondary"
        bg="transparent"
        color={NeoColor.greyscale.black}
        _hover={{ bg: "transparent" }}
        _active={{ bg: "transparent" }}
        onClick={() => {
          void trackPrescriptionWebviewCtaTapped({
            ctaText: historyLabel,
            context: "med_log",
            medicationName,
            ctaAction: MedCtaAction.MedHistory,
          });
          openDeeplink(MEDICATION_HISTORY_DEEPLINK);
        }}
      >
        {historyLabel}
      </Button>
      <Button
        data-cy="treatment-med-log-log"
        size="sm"
        variant="solid"
        colorScheme="primary"
        onClick={() => {
          void trackPrescriptionWebviewCtaTapped({
            ctaText: logLabel,
            context: "med_log",
            medicationName,
            ctaAction: MedCtaAction.LogMedication,
          });
          openDeeplink(MEDICATION_TRACKER_DEEPLINK);
        }}
      >
        <Box display="flex" alignItems="center" gap="4px">
          <img src={plusIcon} alt="" aria-hidden width={16} height={16} />
          <span>{logLabel}</span>
        </Box>
      </Button>
    </Stack>
  );
};
